import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Address } from '../models/Address';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http : HttpClient) { }

  public SaveNewAddress(addy : Address) {
    return this.http.post(environment.baseURl + `/api/address/add`, addy);
  }

  public UpdateAddress(addy : Address) {
    return this.http.post(environment.baseURl + `/api/address/update`, addy);
  }

  public RemoveAddress(addy: Address) {
    return this.http.post(environment.baseURl + '/api/address/delete/', addy);
  }

}
